import { useCallback } from 'react';
import useEventListener from '../../../hooks/useEventListener';
import usePluginHandler from '../../../hooks/usePluginHandler';
import { eventFilter, restoreLastOutside } from '../../../models/clickOut';
import { PluginMessageTypes } from '../../../models/constants';

const messageHandler = (message) => {
  if (message.type === PluginMessageTypes.CLICK_OUTSIDE_RESTORE) {
    window.focus();
    restoreLastOutside(message.payload);
  }
};

/**
 * Reagisce al click sul IFrame.
 */
export default function useClickOutside(enabled, clickEvent) {
  usePluginHandler(messageHandler);

  const onClick = useCallback((event) => {
    // se abilitata la gestione dei click outside e se non si tratta di un evento generato da plugins
    // allora verifico se l'evento deve essere fermato (chiedendolo al child)
    if (enabled && !event.fromPluginsEvent) {
      // se l'evento viene filtrato, non continuo con gli altri eventi di click
      if (eventFilter(event)) return;
    }
    clickEvent(event);
  }, [clickEvent, enabled]);

  useEventListener('click', onClick, true, 'clickOutside');
}
